export default __webpack_public_path__ + "static/carlos-8c5fa8b950fffabda43d8b158ca73e8c.png";